import React from 'react';
import { SidebarStories } from '@benzinga/news';
import styled from '@benzinga/themetron';
import { News, StoryObject } from '@benzinga/basic-news-manager';

interface NewsFeedNodesProps {
  attrs?: any;
  news?: StoryObject[];
}

interface NewsFeedTopStoriesProps {
  attrs?: any;
  title?: string;
  topPosts?: News[];
}

interface NewsFeedProps extends NewsFeedNodesProps, NewsFeedTopStoriesProps {
  top_posts?: News[];
}

export const NewsFeedBlock: React.FC<NewsFeedProps> = props => {
  const news = props.news || props?.attrs?.data?.news;
  if (props.top_posts) {
    return <TopNewsFeed attrs={props.attrs} title={props.attrs?.data.title} topPosts={props.top_posts} />;
  } else if (news) {
    return <NewsFeedNodes attrs={props.attrs} news={news} />;
  }
  return <div />;
};

export const NewsFeedNodes: React.FC<NewsFeedNodesProps> = ({ attrs, news }) => {
  if (!news) return <div />;

  return (
    <NewsFeedWrapper className="block news-feed-wrapper">
      <SidebarStories data={news} hideTickers={attrs?.data?.hide_tickers} showCount={false} title={attrs.data.title} />
    </NewsFeedWrapper>
  );
};

export const TopNewsFeed: React.FC<NewsFeedTopStoriesProps> = ({ title = 'Top Stories', topPosts }) => {
  if (!topPosts) return <div />;

  return (
    <NewsFeedWrapper className="block news-feed-wrapper">
      <SidebarStories data={topPosts} hideTickers={true} title={title} />
    </NewsFeedWrapper>
  );
};

export const NewsFeedWrapper = styled.div`
  &.news-feed-wrapper {
  }
`;
